import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import newAlert from 'src/components/newAlert';
import { FileError } from 'src/components/common/file_error';
import axios from 'src/core/utils/axios';
import apiMain from 'src/api/api_main';

import {
  Button as AntButton,
  Form,
  Select,
  Row,
  Col,
  Upload,
  message,
} from 'antd';

import { CloudUploadOutlined } from '@ant-design/icons';
import { start_loading, end_loading } from 'src/core/actions/loader';
import { typesList, layout, sourceList, fileList } from './data';

const { Option } = Select;

const RegisterFirstModal = ({ onClose = () => {}, setClients = () => {} }) => {
  const dispatch = useDispatch();
  const socket = useSelector((state) => state.socket);
  const version = useSelector((state) => state.version);
  const data_date = useSelector((state) => state.data_date);

  const [form] = Form.useForm();
  const fileSource = Form.useWatch('file_source', form); // Реал тайм хяналт

  const onCancel = () => {
    form.resetFields();
    onClose();
  };

  const normFile = (e) => {
    if (Array.isArray(e)) return e;
    return e && e.fileList;
  };

  const registerBalance = (balance_list) => {
    socket.on('request_out', (data) => {
      socket.removeAllListeners('request_out');

      if (data.content.status === '0') {
        newAlert({
          type: 'success',
          msg: 'Харилцагчийн эхний үлдэгдэл амжилттай хадгалагдлаа',
        });
        setClients(data.content.json_array);
        onCancel();
      } else {
        newAlert({ type: 'error', msg: data.content.msg || 'Алдаа гарлаа' });
      }
      dispatch(end_loading({}));
    });

    socket.emit('request_in', {
      channel: 'ts002_00_eh_uld_register',
      content: {
        action_type: 'register_avlaga_uglug_tovchoo',
        version: version.version_number,
        year: version.year,
        data_type: form.getFieldValue('file_type')?.toString(),
        array_data: balance_list,
      },
    });
    dispatch(start_loading({}));
  };

  const validateDans = (list_data) => {
    socket.on('request_out', (data) => {
      socket.removeAllListeners('request_out');

      const dans_data = data.content.json_array || [];
      const avlaga_uglug_journal = dans_data.filter(
        (x) => x.tuslah_journal_id === 1
      );

      const sums = [
        ...list_data
          .reduce((map, item) => {
            const ets_uld = parseFloat(item.ets_uld || 0);
            const key = item.dans_code;
            const prev = map.get(key);
            if (prev) {
              prev.ets_uld += ets_uld;
            } else {
              map.set(key, { ...item, ets_uld });
            }
            return map;
          }, new Map())
          .values(),
      ];

      const angilagdsan_dans = sums.filter((o1) =>
        avlaga_uglug_journal.some(
          (o2) => o1.dans_code?.toString() === o2.dans_dugaar?.toString()
        )
      );

      const filtered_dans_list = avlaga_uglug_journal.filter((o1) =>
        sums.some(
          (o2) => o1.dans_dugaar?.toString() === o2.dans_code?.toString()
        )
      );

      const diff_arrays = angilagdsan_dans.filter(
        (o1) =>
          !filtered_dans_list.some((o2) => {
            const cred = parseFloat(o2?.dans_dun_cred || 0).toFixed(2);
            const deb = parseFloat(o2?.dans_dun_deb || 0).toFixed(2);
            const uld = parseFloat(o1.ets_uld || 0).toFixed(2);
            return (
              o1.dans_code === o2.dans_dugaar && (cred === uld || deb === uld)
            );
          })
      );

      if (diff_arrays.length > 0) {
        newAlert({
          type: 'warning',
          msg: `${diff_arrays
            .map((x) => x.dans_code)
            .join(', ')} данснуудын үлдэгдэл таарахгүй байна`,
        });
      } else {
        const final_data = list_data.filter((item) =>
          angilagdsan_dans.some((d) => d.dans_code === item.dans_code)
        );
        registerBalance(final_data.length > 0 ? final_data : list_data);
      }

      dispatch(end_loading({}));
    });

    socket.emit('request_in', {
      channel: 'ts001_02_dans_control',
      content: {
        action_type: 'get_dans_dun_list',
        month: 'ets',
        first_year: true,
      },
    });
    dispatch(start_loading({}));
  };

  const handleUpload = async (values) => {
    const { file_source } = values;

    try {
      // API-ээр татах
      if (file_source === 'api') {
        const params = {
          year: version.year,
          data_date,
          file_type: values.file_type,
          version_number: version.version_number,
        };

        const response = await apiMain('smart', 'avalga_uglug', params);
        const { state, data, message: msg } = response || {};

        if (state === true || state === '0') {
          validateDans(data || []);
        } else {
          newAlert({
            type: 'error',
            msg: msg || 'API-с мэдээлэл авахад алдаа гарлаа',
          });
          // dispatch(end_loading({}));
        }
        return;
      }

      // Файлаар оруулах
      const fileList = values.file;

      if (!fileList || fileList.length === 0) {
        dispatch(start_loading({}));
        newAlert({ type: 'warning', msg: 'Файл сонгоогүй байна!' });
        dispatch(end_loading({}));
        return;
      }

      const file = fileList[0].originFileObj;
      const file_size = fileList[0].size;
      const { file_type } = values;

      const formData = new FormData();
      formData.append('file', file);

      const result = await axios.post('first', `/${file_type}`, formData, {
        file_size,
        file_source,
      });

      if (result?.status === '0') {
        validateDans(result.content.json_array || []);
      } else if (result?.content?.type === 'content') {
        FileError({ text: result.content.message });
        dispatch(end_loading({}));
      } else {
        newAlert({
          type: 'error',
          msg: result?.content?.message || 'Файл боловсруулахад алдаа гарлаа',
        });
        dispatch(end_loading({}));
      }
    } catch (err) {
      console.error('handleUpload error:', err);
      newAlert({ type: 'error', msg: 'Системийн алдаа гарлаа' });
      dispatch(end_loading({}));
    }
  };

  const onFinish = (values) => {
    handleUpload(values);
  };

  return (
    <>
      <div style={{ fontStyle: 'italic' }} className="ml-10 mb-10">
        Авлага, өглөгийн товчоо тайлан оруулна уу!
      </div>

      <div className="hariltsagch-medeelel">
        <Form
          form={form}
          onFinish={onFinish}
          layout="horizontal"
          {...layout}
          size="middle"
          className="register-form"
        >
          {/* Эх сурвалж */}
          <Form.Item
            name="file_source"
            label="Эх сурвалж"
            rules={[{ required: true, message: 'Эх сурвалж сонгоно уу!' }]}
          >
            <Select
              placeholder="Сонгох"
              onChange={(value) => {
                if (value === 'api') {
                  form.setFieldsValue({
                    file_type: undefined,
                    file: undefined,
                  });
                }
              }}
            >
              {sourceList.map((x) => (
                <Option value={x.id} key={x.id}>
                  {x.name}
                </Option>
              ))}
            </Select>
          </Form.Item>

          {/* Зөвхөн файлын эх сурвалж сонгоогүй бол харуулах */}

          <Form.Item
            name="file_type"
            label="Файлын төрөл"
            rules={[{ required: true, message: 'Файлын төрөл сонгоно уу!' }]}
          >
            <Select placeholder="Сонгох">
              {fileList.map((x) => (
                <Option value={x.id} key={x.id}>
                  {x.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
          {fileSource !== 'api' && (
            <>
              <Form.Item
                name="file"
                label="Файл"
                valuePropName="fileList"
                getValueFromEvent={normFile}
                rules={[{ required: true, message: 'Файл сонгоно уу!' }]}
              >
                <Upload
                  accept={typesList.join(',')}
                  maxCount={1}
                  beforeUpload={(file) => {
                    const isValid = typesList.includes(file.type);
                    if (!isValid) {
                      message.error('Зөвхөн .xls, .xlsx файл оруулна уу!');
                      return Upload.LIST_IGNORE;
                    }
                    return false;
                  }}
                >
                  <AntButton icon={<CloudUploadOutlined />}>
                    Файл сонгох
                  </AntButton>
                </Upload>
              </Form.Item>
            </>
          )}

          {/* Товчлуурууд */}
          <Row>
            <Col span={24} style={{ textAlign: 'right' }}>
              <Form.Item noStyle>
                <AntButton
                  onClick={onCancel}
                  className="cancel-btn mr-5"
                  type="default"
                  shape="round"
                >
                  Буцах
                </AntButton>
                <AntButton
                  className="confirm-btn"
                  type="primary"
                  shape="round"
                  htmlType="submit"
                >
                  {fileSource === 'api' ? 'API-аас авах' : 'Хадгалах'}
                </AntButton>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
};

export default RegisterFirstModal;
